export default {
  copyright: '© Amous 2024, all rights reserved',
  errors: {
    error404: '404 - Not Found',
    invalidField: 'Invalid Field',
    required: 'Field is required',
    error500: 'Internal Server Error',
    fileImportFailed: 'Failed to import file',
    positiveNumber: 'Should be a positive number',
    sessionHasExpired: 'Your session has expired',
    fieldLengthShouldBeFrom: 'Field length should be from',
    selectAtLeastOneField: 'Please, select at least one field',
    shouldBeAFile: 'Should be a .txt|.csv|.xlsx|.xls|.ods file',
    youDontHaveAnyFieldsForThisReport: 'You don\'t have any fields for this Report',
    youDontHaveAnyFiltersForThisReport: 'You don\'t have any filters for this Report',
    youDontHaveAnySortingForThisReport: 'You don\'t have any sorting for this Report',
    rangeFieldsShouldBothBeEmpty: 'Range fields should both be empty or both filled in',
    selectOperationsFoAllSelectedFilterFields: 'Please, select operations for all selected filter fields',
  },
  labels: {
    to: 'to',
    or: 'or',
    and: 'and',
    fax: 'Fax',
    day: 'day',
    ago: 'ago',
    days: 'days',
    sort: 'Sort',
    list: 'list',
    hours: 'hours',
    login: 'Login',
    fields: 'Fields',
    filter: 'Filter',
    pcFlag: 'Pc Flag',
    hmFlag: 'Hm Flag',
    logOut: 'Log Out',
    usMail: 'Us Mail',
    phyZip: 'Phy Zip',
    minutes: 'minutes',
    started: 'Started',
    migrant: 'Migrant',
    phyCity: 'Phy City',
    dbaName: 'Dba Name',
    addDate: 'Add Date',
    opOther: 'Op Other',
    username: 'Username',
    password: 'Password',
    phyState: 'Phy State',
    oicState: 'Oic State',
    isExists: 'Is Exists',
    marketing: 'marketing',
    telephone: 'Telephone',
    phyStreet: 'Phy Street',
    legalName: 'Legal Name',
    dotNumber: 'Dot Number',
    characters: 'characters',
    mailingZip: 'Mailing Zip',
    mcs150Date: 'Mcs150 Date',
    selectDate: 'Select Date',
    reportName: 'Report name',
    phyCountry: 'Phy Country',
    enterValue: 'Enter a Value',
    privateOnly: 'Private Only',
    indianTribe: 'Indian Tribe',
    driverTotal: 'Driver Total',
    mailingCity: 'Mailing City',
    vmtSourceId: 'Vmt Source Id',
    isNewStatus: 'Is New Status',
    emailAddress: 'Email Address',
    selectReport: 'Select Report',
    amousWebsite: 'Amous Website',
    mailingState: 'Mailing State',
    nbrPowerUnit: 'Nbr Power Unit',
    mailingStreet: 'Mailing Street',
    marketingList: 'marketing list',
    recentMileage: 'Recent Mileage',
    mcs150Mileage: 'Mcs150 Mileage',
    exemptForHire: 'Exempt For Hire',
    amousTmsLogin: 'Amous TMS Login',
    marketingListUi: 'Marketing List',
    mailingCountry: 'Mailing Country',
    stateGovernment: 'State Government',
    privateProperty: 'Private Property',
    localGovernment: 'Local Government',
    fileNotImported: 'File not imported',
    contactTimeZone: 'Contact Time Zone',
    carrierOperation: 'Carrier Operation',
    importedFileDate: 'Import date of file',
    federalGovernment: 'Federal Government',
    recentMileageYear: 'Recent Mileage Year',
    mcs150MileageYear: 'Mcs150 Mileage Year',
    authorizedForHire: 'Authorized For Hire',
    importFileStarted: 'File import started',
    clickToUploadFile: 'Click to upload file',
    importedFileStatus: 'Imported file status',
    exactMatchingFilters: 'Exact matching filters(and)',
    byClickingLog: 'By clicking Log in you agree to our',
    privatePassengerBusiness: 'Private Passenger Business',
    privatePassengerNonbusiness: 'Private Passenger Nonbusiness',
    sorryThePageNotFound: 'Sorry, the page you are looking for might be in another universe.',

    // user profile
    user: 'User',
    group: 'Group',
    phone: 'Phone',
    email: 'Email',
    fullName: 'Full Name',
    lastName: 'Last Name',
    firstName: 'First Name',
    userProfile: 'User Profile',

    // statuses
    active: 'Active',
    failed: 'Failed',
    disabled: 'Disabled',

    // report
    in: 'In',
    no: 'No',
    end: 'End',
    yes: 'Yes',
    less: 'Less',
    DAYS: 'Days',
    more: 'More',
    Hours: 'Hours',
    equal: 'Equal',
    range: 'Range',
    begin: 'Begin',
    HOURS: 'Hours',
    WEEKS: 'Weeks',
    notIn: 'Not In',
    MONTHS: 'Months',
    not_in: 'Not In',
    notEnd: 'Not End',
    not_end: 'Not End',
    contain: 'Contain',
    notLess: 'Not Less',
    notMore: 'Not More',
    not_less: 'Not Less',
    not_more: 'Not More',
    notEqual: 'Not Equal',
    notBegin: 'Not Begin',
    not_begin: 'Not Begin',
    not_equal: 'Not Equal',
    dateRange: 'Date Range',
    notContain: 'Not Contain',
    not_contain: 'Not Contain',
    'date-range': 'Date Range',
    chooseValue: 'Choose a value',
    downloadFile: 'Download File',
    choose_value: 'Choose a value',
  },
  actions: {
    ok: 'Ok',
    add: 'Add',
    use: 'Use',
    book: 'Book',
    save: 'Save',
    edit: 'Edit',
    block: 'Block',
    apply: 'Apply',
    close: 'Close',
    delete: 'Delete',
    upload: 'Upload',
    remove: 'Remove',
    cancel: 'Cancel',
    update: 'Update',
    confirm: 'Confirm',
    unblock: 'Unblock',
    resetAll: 'Reset All',
    tryAgain: 'Try Again',
    addField: 'Add Field',
    addFilter: 'Add Filter',
    addFields: 'Add Fields',
    removeAll: 'Remove All',
    saveAsNew: 'Save As New',
    editReport: 'Edit Report',
    uploadFile: 'Upload File',
    editColumns: 'Edit Columns',
    dragAndDrop: 'Drag And Drop',
    createNewReport: 'Create new report',
    removeChosenFile: 'Remove Chosen File',

    hide: 'Hide',
    show: 'Show',
    login: 'Log In',
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms & Conditions',
  },
  titles: {
  },
  descriptions: {
  },
  messages: {
    emptySearch: 'No recent searches yet',
  },
};
